module.exports = __webpack_public_path__ + "static/assets/7d88b0bed3af178f580a7432a653488d.png";